import React from "react";

import { useTranslation } from "react-i18next";

import { Bet } from "@models";
import { BetCancelStore } from "@state/stores/my-bets/BetCancelStore";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";

export const BetDetailsBetCancelButton = (props: {
	store: BetDetailsModalStore | BetSlipReceiptModalStore;
	bet: Bet;
}) => {
	const { t } = useTranslation("mybets");

	let cancelStore: BetCancelStore;

	if (props.store instanceof BetSlipReceiptModalStore) {
		cancelStore = props.store.betCancelStore;
	} else {
		cancelStore = props.store.myBetsStore.betCancelStore;
	}

	if (cancelStore == null) {
		return null;
	}

	if (!props.bet.isCancellationAvailable) {
		return null;
	}

	if (cancelStore.betCancelMessage !== null) {
		return null;
	}

	return (
		<button
			className="bet__btn btn btn--med btn--block btn--danger--inverted"
			type="button"
			onClick={() => {
				cancelStore.onBetCancelBetDetailsModal(props.bet);
				props.store.onBetCancelOpen();
			}}
		>
			{t<string>("ITEM.CANCEL_BET")}
		</button>
	);
};
